"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Textarea = void 0;
const core_1 = require("@material-ui/core");
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const textarea_style_1 = require("./textarea.style");
exports.Textarea = react_1.default.forwardRef((_a, ref) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const textAreaStyles = textarea_style_1.useTextareaStyles();
    return react_1.default.createElement(core_1.TextareaAutosize, Object.assign({ ref: ref, className: classnames_1.default(textAreaStyles.root, className) }, props));
});
exports.Textarea.defaultProps = {
    rowsMin: 3,
};
//# sourceMappingURL=textarea.js.map